// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2Y35d","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1By9v"};